import ClientDocuments from './ClientDocuments';

export default ClientDocuments;
